import { auth } from './firebase';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3070'; // Updated to 3070 to match your backend

async function getToken() {
  const user = auth.currentUser;
  // If user is null, we return null rather than throwing to avoid early crashes
  // during the initial Firebase boot-up.
  return user ? user.getIdToken() : null;
}

async function apiFetch(path, options = {}) {
  const token = await getToken();
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  if (!res.ok) throw new Error(`API error ${res.status}`);

  return res.json();
}
export { apiFetch };
export const api = {
  // User
  registerUser: (payload) =>
    apiFetch('/api/users/register', { method: 'POST', body: JSON.stringify(payload) }),

  // Workspaces
  getWorkspaces: () => apiFetch('/api/workspaces'),
  getWorkspace: (id) => apiFetch(`/api/workspaces/${id}`),
  createWorkspace: (payload) =>
    apiFetch('/api/workspaces', { method: 'POST', body: JSON.stringify(payload) }),
  runWorkspace: (id) =>
    apiFetch(`/api/workspaces/${id}/run`, { method: 'POST' }),

  // Tasks
  getTasks: (workspaceId) =>
    apiFetch(`/api/workspaces/${workspaceId}/tasks`),

  // Artifacts (Moved inside the api object)
  getArtifacts: (workspaceId) =>
    apiFetch(`/api/workspaces/${workspaceId}/artifacts`),

  getArtifact: (artifactId) =>
    apiFetch(`/api/artifacts/${artifactId}`),

  getArtifactVersions: (workspaceId, artifactId) =>
    apiFetch(`/api/workspaces/${workspaceId}/artifacts/${artifactId}/versions`),


getCampaign:        (artifactId) =>
  apiFetch(`/api/campaigns/${artifactId}`),

updateCampaignCopy: (artifactId, payload) =>
  apiFetch(`/api/campaigns/${artifactId}`, {
    method: 'PATCH',
    body:   JSON.stringify(payload),
  }),

exportCampaignPng:  (artifactId, platform) =>
  apiFetch(`/api/campaigns/${artifactId}/export/${platform}`, { method: 'POST' }),

downloadCampaignPng: (artifactId, platform) =>
  apiFetch(`/api/campaigns/${artifactId}/download/${platform}`),


};